import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ResponsiveContainer, BarChart, XAxis, YAxis, Tooltip, Bar, Cell } from "recharts";
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { format, parseISO } from 'date-fns';

// Get all time buckets (column names)
const url=process.env.REACT_APP_SERVER_URL;

// Define color scale helper
const getIntensityColor = (value) => {
  if (value === 0) return "#f0f0f0";
  if (value < 3) return "#a7d7c5";
  if (value < 6) return "#5fb49c";
  return "#157a6e";
};
const CallLogsGraph = ({callLogs, showCallLogGraph, setShowCallLogGraph}) => {
    const [heatMapData, setHeatMapData] = useState([])
    useEffect(() => {
        formatCallLogData()
        
    }, []);
    
const timeBuckets = heatMapData.length>0 ? Object.keys(heatMapData[0]).filter(k => k !== "date") : [];

    const formatCallLogData = () =>{
        // Step 1: Create 2-hour time buckets
    const hourBuckets = Array.from({ length: 12 }, (_, i) => {
        const start = (i * 2).toString().padStart(2, "0");
        const end = (i * 2 + 1).toString().padStart(2, "0");
        return `${start}:00–${end}:59`;
    });
    console.log(hourBuckets)
  
  // Step 2: Group and count
  const startDate = new Date('2025-04-01');
  const endDate = new Date('2025-04-30');
  
  // 🔁 Step 1: Initialize date range with empty counts
  const result = {};
  const current = new Date(startDate);
  while (current <= endDate) {
    const day = current.toISOString().slice(0, 10);
    result[day] = { date: day };
    hourBuckets.forEach(label => {
      result[day][label] = 0;
    });
    current.setDate(current.getDate() + 1); // Go to next day
  }
  
  for (const call of callLogs) {

    const dateObj = new Date(call.callDate); // auto converts UTC to local
    const hour = dateObj.getHours(); // 0 to 23
    const day = dateObj.toISOString().slice(0, 10); // e.g., "2025-04-01"
    if (dateObj < startDate || dateObj > endDate) continue;
    console.log(hour  +  ' ' + day);
    // Find the 2-hour bucket index
    const bucketIndex = Math.floor(hour / 2);
    const bucketLabel = hourBuckets[bucketIndex];
    console.log(bucketLabel);
  
    // Initialize the day entry if not present
    // if (!(day in result)) {
    //   result[day] = { date: day };
    //   hourBuckets.forEach(label => {
    //     result[day][label] = 0;
    //   });
    // }
  
    // Increment count for that 2-hour window
    result[day][bucketLabel]++;
  }
  
  // Step 3: Convert to array for heatmap
  const resultArray = Object.values(result);
  
  console.log(resultArray);
  setHeatMapData(resultArray);
  return resultArray;
    }
    function handleCloseCallLogGraph(){
        setShowCallLogGraph(false)
    }
    return (
        <Dialog open={showCallLogGraph} onClose={handleCloseCallLogGraph} maxWidth="lg" fullWidth>
        
              <DialogContent dividers>
              <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={heatMapData}
        layout="vertical"
        barCategoryGap="10%"
      >
        <XAxis type="number" 
          dataKey={() => 1} // fixed width blocks
          
          domain={[0, timeBuckets.length-1]} 
          ticks={timeBuckets.map((_, i) => i)}
        tickFormatter={(index) => timeBuckets[index]}
        interval={0}
        // angle={-45}
        tick={{ fontSize: 11 }}
        height={70}
          />
        <YAxis dataKey="date" type="category" width={100} 
        tickFormatter={(value) => format(parseISO(value), "MMM d")}/>
        {timeBuckets.map((bucket, index) => (
          <Bar key={bucket} dataKey={bucket} stackId="a" isAnimationActive={false}>
            {heatMapData.map((entry, i) => (
              <Cell key={`cell-${i}-${index}`} fill={getIntensityColor(entry[bucket])} />
            ))}
          </Bar>
        ))}
        <Tooltip />
      </BarChart>
    </ResponsiveContainer>

    </DialogContent>
    </Dialog>
        
    )
}
export default CallLogsGraph;